import {useManagedMutation} from '@pinecast/gql';
import type {
  RequestLoginForSubscriptionCheckoutSession,
  RequestLoginForSubscriptionCheckoutSessionVariables,
} from '@pinecast/gql/__generated_tj__/RequestLoginForSubscriptionCheckoutSession';
import gql from 'graphql-tag';

export const REQUEST_LOGIN = gql`
  mutation RequestLoginForSubscriptionCheckoutSession(
    $podcastSlug: ID!
    $amount: Int!
    $email: String
    $oneTime: Boolean
    $receiveUpdates: Boolean
  ) {
    createSubscriptionCheckoutSession(
      podcastSlug: $podcastSlug
      amount: $amount
      email: $email
      oneTime: $oneTime
      receiveUpdates: $receiveUpdates
    ) {
      nextState
      sessionId
    }
  }
`;

export const useGetSubscriptionCheckoutSession = () => {
  return useManagedMutation<
    RequestLoginForSubscriptionCheckoutSession,
    RequestLoginForSubscriptionCheckoutSessionVariables
  >(REQUEST_LOGIN);
};
